import PropTypes from 'prop-types';
import React from 'react';
import {
  CardCheckbox as Checkbox,
  CardDateTime as DateTime,
  CardTextArea as TextArea,
  CardTZSelect as TZSelect,
  CardInput as Input,
  TextArea as Textarea
} from '../../Elements';
import { DeleteConfirmation, MobileModal, GlobalNotifications, Intent } from '../../Modules';
import fieldStyles from '../../Elements/CardField/CardField.scss';
import moment from 'moment-timezone';
import { Button } from 'semantic-ui-react';
import Formsy from 'formsy-react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../../../lib/stylesheets/ExpandCollapseTransition.css';
import LocationAutocomplete from './LocationAutocomplete';

export default class EventSegmentMobile extends React.Component {

  static propTypes = {
    localEventSegment: PropTypes.object.isRequired,
    commitUpdate: PropTypes.func,
    reset: PropTypes.func,
    delete: PropTypes.func,
    onChange: PropTypes.func,
    closeHandler: PropTypes.func,
    open: PropTypes.bool,
    index: PropTypes.number,
    closeEditor: PropTypes.func,
    isNew: PropTypes.bool,
    submissionAttempts: PropTypes.number,
    viewer: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      submitted: this.props.submissionAttempts > 0,
      endAtKey: this.generateKey()
    };
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.endAtChange = this.endAtChange.bind(this);
    this.startAtChange = this.startAtChange.bind(this);
    this.tzChange = this.tzChange.bind(this);
    this.allDayChange = this.allDayChange.bind(this);
    this.reset = this.reset.bind(this);
    this.delete = this.delete.bind(this);
    this.commitUpdate = this.commitUpdate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.generateKey = this.generateKey.bind(this);
  }

  componentWillMount() {
    const { localEventSegment, viewer } = this.props;
    if (!localEventSegment.time_zone) {
      const timeZone = (viewer && viewer.s_time_zone) || moment.tz.guess();
      this.fieldChange('time_zone', timeZone);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.submissionAttempts !== this.props.submissionAttempts) {
      this.refs.form.submit();
      this.setState({ submitted: nextProps.submissionAttempts > 0 });
    }
  }

  componentWillUnmount() {
    if (this.props.closeEditor) this.props.closeEditor();
  }

  onSubmit(data, reset, invalidateForm) {
    this.setState({ submitted: true });
    if (new Date(data.ends_at) < new Date(data.starts_at)) {
      GlobalNotifications.show({ message: 'Unable to update event information', intent: Intent.DANGER });
      invalidateForm({ ends_at: 'Event must end later than it starts' });
    } else {
      this.props.commitUpdate(this.props.index, () => this.props.closeHandler());
    }
  }

  getUtcDate(date) {
    return moment.tz(date, this.props.localEventSegment.time_zone).toISOString();
  }

  getDateString(date) {
    const { all_day, time_zone } = this.props.localEventSegment;
    // eslint-disable-next-line camelcase
    if (all_day) {
      return moment(date).format('YYYY-MM-DD');
    }
    return moment.tz(date, time_zone).toISOString();
  }

  generateKey() {
    return (`${Math.random().toString(36)}00000000000000000`).slice(2, 16 + 2);
  }

  commitUpdate() {
    this.setState({ submitted: true });
    this.props.commitUpdate(this.props.index, () => {
      setTimeout(() => this.props.closeHandler(), 0);
    });
  }

  reset() {
    this.props.reset(this.props.index);
    setTimeout(() => this.props.closeHandler(), 0);
  }

  delete(e) {
    e.preventDefault();
    this.props.delete(this.props.index, () => this.props.closeHandler);
  }

  textFieldChange(e) {
    this.fieldChange(e.target.name, e.target.value);
  }

  tzChange(e, { value }) {
    const { start_at, end_at } = this.props.localEventSegment;
    if (moment(start_at, moment.ISO_8601).isValid()) {
      this.fieldChange('start_at', this.getDateString(start_at));
    }
    if (moment(end_at, moment.ISO_8601).isValid()) {
      this.fieldChange('end_at', this.getDateString(end_at));
    }
    this.fieldChange('time_zone', value);
  }


  fieldChange(key, value) {
    const newValue = {};
    newValue[key] = value;
    this.props.onChange(Object.assign(this.props.localEventSegment, newValue));
  }

  endAtChange(e) {
    const isDate = e.target.value.length === 10;
    this.fieldChange('end_at', isDate ? e.target.value : this.getUtcDate(e.target.value));
  }

  startAtChange(e) {
    const isDate = e.target.value.length === 10;
    this.fieldChange('start_at', isDate ? e.target.value : this.getUtcDate(e.target.value));
    if (
      (!this.props.localEventSegment.end_at ||
        moment(this.props.localEventSegment.end_at) <=
          moment(this.props.localEventSegment.start_at))
    ) {
      if (isDate && moment(e.target.value, moment.ISO_8601).isValid()) {
        this.fieldChange('end_at', e.target.value);
      } else if (moment(e.target.value).isValid()) {
        this.fieldChange(
          'end_at',
          moment(e.target.value)
            .add(4, 'hours')
            .toDate()
            .toISOString()
        );
      }
      this.setState({ endAtKey: this.generateKey() });
    }
  }

  allDayChange() {
    const allDay = !this.props.localEventSegment.all_day;
    const timeZone = this.props.localEventSegment.time_zone;
    this.fieldChange('all_day', allDay);
    if (moment(this.props.localEventSegment.start_at).isValid()) {
      const startAt = allDay
        ? moment.tz(this.props.localEventSegment.start_at, timeZone).format('YYYY-MM-DD')
        : moment.tz(this.props.localEventSegment.start_at, timeZone).toISOString();
      this.fieldChange('start_at', startAt);
    }
    if (moment(this.props.localEventSegment.end_at).isValid()) {
      const endAt = allDay
        ? moment.tz(this.props.localEventSegment.end_at, timeZone).format('YYYY-MM-DD')
        : moment.tz(this.props.localEventSegment.end_at, timeZone).add(4, 'hours').toISOString();
      this.fieldChange('end_at', endAt);
    }
  }

  render() {
    const eventSegment = this.props.localEventSegment;
    const deleteButton = (
      <Button negative fluid type='button'>
        Delete Event Time
      </Button>
    );
    return (
      <Formsy.Form className='ui form' ref='form' onSubmit={this.onSubmit}>
        <MobileModal
          open={this.props.open}
          onClose={this.props.closeHandler}
          inline
        >
          <MobileModal.Header>
            <div className='menu'>
              <a className='item' onClick={this.reset}>
                Cancel
              </a>
            </div>
            <div className='right menu'>
              <a className='item' onClick={() => this.refs.form.submit()}>
                Save
              </a>
            </div>
          </MobileModal.Header>
          <MobileModal.Content>
            <h4>
              <Textarea
                className={`transparent fluid ${fieldStyles.textArea}`}
                rows={1}
                placeholder='Description (eg. Reception)'
                value={eventSegment.title || ''}
                onChange={this.textFieldChange}
                name='title'
                submitted={this.state.submitted}
              />
            </h4>
            <br />
            <Checkbox
              label='All-day'
              name='all_day'
              checked={eventSegment.all_day || false}
              onChange={this.allDayChange}
              submitted={this.state.submitted}
            />
            <DateTime
              label='Starts'
              name='starts_at'
              placeholder='Start Time'
              value={eventSegment.start_at || ''}
              timeZone={eventSegment.time_zone}
              dateOnly={eventSegment.all_day || false}
              onChange={this.startAtChange}
              submitted={this.state.submitted}
            />
            <DateTime
              label='Ends'
              name='ends_at'
              placeholder='End Time'
              value={eventSegment.end_at || ''}
              timeZone={eventSegment.time_zone}
              dateOnly={eventSegment.all_day || false}
              onChange={this.endAtChange}
              submitted={this.state.submitted}
              key={this.state.endAtKey}
              validationError='Event must end later than it starts'
            />
            <ReactCSSTransitionGroup
              transitionName='background'
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
              style={{ margin: '1em 0' }}
            >
              {eventSegment.start_at && eventSegment.end_at && !eventSegment.all_day &&
                <div style={{ margin: '1em 0' }}>
                  <TZSelect
                    label='Time Zone'
                    name='time_zone'
                    value={eventSegment.time_zone}
                    onChange={this.tzChange}
                    submitted={this.state.submitted}
                    validationError='Time zone is required'
                  />
                </div>}
            </ReactCSSTransitionGroup>
            <LocationAutocomplete
              eventSegment={eventSegment}
              updateLocalEventSegment={this.props.onChange}
            />
            <ReactCSSTransitionGroup
              transitionName='background'
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
              style={{ margin: '1em 0' }}
            >
            {eventSegment.location && eventSegment.location !== '' &&
              <div style={{ margin: '1em 0' }}>
                <TextArea
                  label='Address'
                  name='line1'
                  placeholder='4900 Chagrin Drive'
                  value={eventSegment.line1 || ''}
                  onChange={this.textFieldChange}
                  submitted={this.state.submitted}
                />
                <TextArea
                  label='City'
                  name='city'
                  placeholder='San Francisco'
                  value={eventSegment.city || ''}
                  onChange={this.textFieldChange}
                  submitted={this.state.submitted}
                />
                <TextArea
                  label='State/&#8203;Province'
                  name='province'
                  placeholder='California'
                  value={eventSegment.province || ''}
                  onChange={this.textFieldChange}
                  submitted={this.state.submitted}
                />
                <Input
                  label='Postal Code'
                  name='postal_code'
                  type='tel'
                  placeholder='94105'
                  value={eventSegment.postal_code || ''}
                  onChange={this.textFieldChange}
                  submitted={this.state.submitted}
                />
                <TextArea
                  label='Room'
                  name='room'
                  placeholder='Grand Ballroom'
                  value={eventSegment.room || ''}
                  onChange={this.textFieldChange}
                  submitted={this.state.submitted}
                />
              </div>
            }
            </ReactCSSTransitionGroup>
            <TextArea
              label='Notes'
              name='notes'
              value={eventSegment.notes || ''}
              placeholder='Cocktail hour will be in the foyer area'
              onChange={this.textFieldChange}
              submitted={this.state.submitted}
            />
            {this.props.delete && !this.props.isNew &&
              <div>
                <div style={{ flex: 1 }}></div>
                <div style={{ textAlign: 'center', marginTop: '2em' }}>
                  <DeleteConfirmation trigger={deleteButton} delete={this.delete} id={eventSegment.id} />
                </div>
              </div>
            }
          </MobileModal.Content>
        </MobileModal>
      </Formsy.Form>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Event/EventSegment/EventSegmentMobile.js